import { RootState } from '../store';

export const selectClientOptions = (state: RootState) => state.client.clientOptions;

export const selectClientOptionsRequestStatus = (state: RootState) => state.client.clientOptionsRequestStatus;
